/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

/**
 * @module bulb-comment/bulbcommentui
 */

import { Plugin, ButtonView, type Locale } from 'ckeditor5';

import bulbCommentIcon from '../../assets/toolbar_icons/comment_icon.svg';
import { addComment } from './util';

/**
 * Plugin to enable comment button inside toolbar for all elements.
 *
 * @extends Plugin
 */
export default class BulbCommentUI extends Plugin {

  /**
     * @inheritDoc
     */
  public init(): void {
    const { editor } = this;
    const { t } = editor;

    editor.ui.componentFactory.add('bulbComment', (locale: Locale): ButtonView => {
      // The button will be an instance of ButtonView.
      const buttonView = new ButtonView(locale);

      buttonView.set({
        label: t('toolbar_comment_rollover'),
        icon: bulbCommentIcon,
        tooltip: true,
      });

      // Callback executed once the button is clicked:
      buttonView.on('execute', () => {
        editor.model.change(() => {
          // Grab the currently selected block on which we are going to add comment.
          addComment(editor);
        });
      });

      return buttonView;
    });
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbCommentUI' as const;
  }
}
